import { useCallback } from 'react'
import { useWireValue } from '@forminator/react-wire'
import { user as storeUser } from '@store'
import { relativeTime } from '@/utils/date'
import cn from 'clsx'

import { Link } from 'react-router-dom'
import { FaTrash } from 'react-icons/fa'
import { sortBy } from '@/utils'

const OrganizationsTable = ({
    className,
    organizations,
    setPendingDeleteOrg,
}) => {
    
    const user = useWireValue(storeUser)
    
    const isOrgOwner = useCallback(org => (
        org.members
            ?.find(it => it.id === user.id)
            ?.UserOrganizationJoin?.memberRole === 'owner'
    ), [user])
    
    if (organizations.length < 1) return (
        <div className={cn('OrganizationsTable mt-4 card', className)}>
            <div className="card-body">
                <p>You have no organizations yet.</p>
            </div>
        </div>
    )
    
    return (
        
        <div className={cn('OrganizationsTable mt-4 card', className)}>
            
            <table className="w-full table-auto">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Created</th>
                        <th>Members</th>
                        <th>{/* Actions */}</th>
                    </tr>
                </thead>
                <tbody>
                    {sortBy(organizations, 'createdAt', 'date', false)?.map(it => {
                        
                        const isOwner = isOrgOwner(it)
                        
                        return (
                            
                            <tr key={`organization-${it.id}`}>
                                <td>
                                    <Link to={`/settings/orgs/${it.id}`}>
                                        {it.name}
                                    </Link>
                                </td>
                                <td>{relativeTime(it.createdAt)}</td>
                                <td>{it.members?.length ?? 0}</td>
                                <td>
                                    <div className="flex items-center content-center justify-end">
                                        <button
                                            className={cn('w-auto btn btn-link', {
                                                'text-red-800 hover:text-red-500': isOwner,
                                                'text-gray-800 hover:text-gray-500 !bg-transparent': !isOwner,
                                            })}
                                            title="Delete Organization"
                                            disabled={!isOwner}
                                            onClick={() => setPendingDeleteOrg(it)}>
                                            <FaTrash/>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                            
                        )
                        
                    })}
                </tbody>
            </table>
            
            {/* <div><pre><code>{JSON.stringify({ organizations }, null, 4)}</code></pre></div> */}
        
        </div>
        
    )
    
}

export default OrganizationsTable
